import React from 'react'
import { mergeClassnames } from '@mote/helpers'
import { __DEV__ } from '@mote/helpers/constants'
import styled from '@xstyled/styled-components'
import { TableGenericContext } from './tableGeneric.context'

export const TableBody = React.forwardRef(
  ({ className, as = 'tbody', ...props }, ref) => {
    return (
      <TableGenericContext.Provider value={{ variant: 'body' }}>
        <TableBodyRoot
          as={as}
          className={mergeClassnames('mote-table-body', className)}
          ref={ref}
          role={as === 'tbody' ? null : 'rowgroup'}
          {...props}
        />
      </TableGenericContext.Provider>
    )
  }
)

if (__DEV__) {
  TableBody.displayName = 'TableBody'
}

const TableBodyRoot = styled.theadBox`
  display: table-row-group;
`
